<div class="card">
  <div class="header">
    <div>
      <span>Série</span>
      <span>{{ nfse?.serie }}</span>
    </div>
    <div>
      <span>Nº</span>
      <span>{{ nfse?.numero }}</span>
    </div>
  </div>
  <div class="body">
    <div class="prop tomador">
      <small>TOMADOR: </small>
      <span class="tomador-info">
        <span class="nome" *ngIf="nfse?.tomadorNome">{{ nfse?.tomadorNome }}</span>
        <span class="documento" [class.sem-nome]="!nfse?.tomadorNome">
          {{ nfse?.tomador | formatter: "cpfCnpj" }}
        </span>
      </span>
    </div>
    <div class="prop">
      <small>VALOR: </small>
      <span>{{ nfse?.valorServico | currency: "BRL" }}</span>
    </div>
    <div class="prop">
      <small>SITUAÇÃO: </small>
      <span [ngClass]="nfse?.situacao?.toLowerCase()">{{
        nfse?.situacao
      }}</span>
    </div>
    <div class="prop">
      <small>EMISSÃO: </small>
      <span>{{ nfse?.emissao }}</span>
    </div>
    <div class="info-container">
      <i
        class="pi pi-info-circle tooltip-icon"
        role="button"
        tabindex="0"
        aria-label="Exibir detalhes da nota"
        (click)="showOverlay($event)"
        (keydown.enter)="showOverlay($event)"
      ></i>

      <p-overlayPanel
        #overlay
        appendTo="body"
        [style]="{ 'min-width': '200px' }"
      >
        <div class="copy-container">
          <p><strong>ID:</strong> {{ nfse?.id }}</p>

          <button type="button" (click)="copyToClipboard(nfse?.id)">
            <i class="pi pi-copy"></i> Copiar
          </button>
        </div>
      </p-overlayPanel>
    </div>
  </div>
  <div class="rejeicao" *ngIf="rejeicao() as rej">
    <strong><i class="pi pi-wrench"></i> {{ rej.titulo }}</strong>
    <span class="motivo">
      {{ rej.descricao }}
      <small *ngIf="rej.codigoPrefeitura">
        Código da prefeitura: {{ rej.codigoPrefeitura }}
      </small>
    </span>
    <span class="como">{{ rej.comoCorrigir }}</span>
    <app-button
      *ngIf="rej.ancora || rej.painel"
      [dense]="true"
      [fullWidth]="true"
      [text]="rej.acaoRotulo ?? 'Corrigir'"
      icon="pi-wrench"
      backgroundColor="var(--orange-500)"
      (click)="irParaCorrecao()"
      (keydown.enter)="irParaCorrecao()"
    ></app-button>
  </div>
  <div class="footer">
    <div class="content">
      <p-menu #menu [model]="menuOptions()" [popup]="true"></p-menu>
      <app-button
        text="Opções"
        icon="pi-bars"
        (click)="menu.toggle($event)"
        backgroundColor="var(--violet-500)"
        textAlign="flex-start"
        [fullWidth]="true"
        [disabled]="nfse?.situacao === 'PROCESSANDO'"
      ></app-button>
    </div>
  </div>
</div>
